import React, { Component } from 'react';

import Grid from '@material-ui/core/Grid';

import Table, { DataTableLineTotals as Totals } from '../../components/Table/Table';
import Legenda from '../../components/Legenda/Legenda';
import {
    PAGE,
    TOTAL_ELEMENTS,
    TOTAL_PAGES,
} from '../../components/Table/Utils';

import { numberFormat } from '../../helper/MaskHelper';

import { patternModalidade } from '../../variables/Enums/Escola';

export class DadosCertificados extends Component {
    constructor (props) {
        super(props);
        this.state = {
            page: PAGE,
            size: 25,
            totalElements: TOTAL_ELEMENTS,
            totalPages: TOTAL_PAGES,
        }
    }

    sumEscolas = () => this.props.schools.length;

    sumAlunosOuro = () => {
        const mirim1AlunosOuro = this.props.schools.reduce((total, sch) => total + parseInt(sch.mirim1.alunosOuro, 10), 0)
        const mirim2AlunosOuro = this.props.schools.reduce((total, sch) => total + parseInt(sch.mirim2.alunosOuro, 10), 0)
        const totalAlunosOuro = this.props.schools.reduce((total, sch) => total + parseInt(sch.total.alunosOuro, 10), 0)
        
        return (<Legenda params={[ mirim1AlunosOuro ?? 0, mirim2AlunosOuro ?? 0, totalAlunosOuro ?? 0 ]} />);
    }

    sumAlunosPrata = () => {
        const mirim1AlunosPrata = this.props.schools.reduce((total, sch) => total + parseInt(sch.mirim1.alunosPrata, 10), 0)
        const mirim2AlunosPrata = this.props.schools.reduce((total, sch) => total + parseInt(sch.mirim2.alunosPrata, 10), 0)
        const totalAlunosPrata = this.props.schools.reduce((total, sch) => total + parseInt(sch.total.alunosPrata, 10), 0)
        
        return (<Legenda params={[ mirim1AlunosPrata ?? 0, mirim2AlunosPrata ?? 0, totalAlunosPrata ?? 0 ]} />);
    }

    sumAlunosBronze = () => {
        const mirim1AlunosBronze = this.props.schools.reduce((total, sch) => total + parseInt(sch.mirim1.alunosBronze, 10), 0)
        const mirim2AlunosBronze = this.props.schools.reduce((total, sch) => total + parseInt(sch.mirim2.alunosBronze, 10), 0)
        const totalAlunosBronze = this.props.schools.reduce((total, sch) => total + parseInt(sch.total.alunosBronze, 10), 0)

        return (<Legenda params={[ mirim1AlunosBronze ?? 0, mirim2AlunosBronze ?? 0, totalAlunosBronze ?? 0 ]} />);
    }

    sumAlunosParticipacao = () => {
        const mirim1AlunosParticipacao = this.props.schools.reduce((total, sch) => total + parseInt(sch.mirim1.alunosParticipacao, 10), 0)
        const mirim2AlunosParticipacao = this.props.schools.reduce((total, sch) => total + parseInt(sch.mirim2.alunosParticipacao, 10), 0)
        const totalAlunosParticipacao = this.props.schools.reduce((total, sch) => total + parseInt(sch.total.alunosParticipacao, 10), 0)

        return (<Legenda params={[ mirim1AlunosParticipacao ?? 0, mirim2AlunosParticipacao ?? 0, totalAlunosParticipacao ?? 0 ]} />);
    }

    sumMaxOuro = () => {
        const mirim1MaxOuro = this.props.schools.reduce((total, sch) => total + parseInt(sch.mirim1.maxOuro, 10), 0)
        const mirim2MaxOuro = this.props.schools.reduce((total, sch) => total + parseInt(sch.mirim2.maxOuro, 10), 0)
        const totalMaxOuro = this.props.schools.reduce((total, sch) => total + parseInt(sch.total.maxOuro, 10), 0)
        
        return (<Legenda params={[ mirim1MaxOuro ?? 0, mirim2MaxOuro ?? 0, totalMaxOuro ?? 0 ]} />);
    }

    sumMaxPrata = () => {
        const mirim1MaxPrata = this.props.schools.reduce((total, sch) => total + parseInt(sch.mirim1.maxPrata, 10), 0)
        const mirim2MaxPrata = this.props.schools.reduce((total, sch) => total + parseInt(sch.mirim2.maxPrata, 10), 0)
        const totalMaxPrata = this.props.schools.reduce((total, sch) => total + parseInt(sch.total.maxPrata, 10), 0)
        
        return (<Legenda params={[ mirim1MaxPrata ?? 0, mirim2MaxPrata ?? 0, totalMaxPrata ?? 0 ]} />);
    }

    sumMaxBronze = () => {
        const mirim1MaxBronze = this.props.schools.reduce((total, sch) => total + parseInt(sch.mirim1.maxBronze, 10), 0)
        const mirim2MaxBronze = this.props.schools.reduce((total, sch) => total + parseInt(sch.mirim2.maxBronze, 10), 0)
        const totalMaxBronze = this.props.schools.reduce((total, sch) => total + parseInt(sch.total.maxBronze, 10), 0)

        return (<Legenda params={[ mirim1MaxBronze ?? 0, mirim2MaxBronze ?? 0, totalMaxBronze ?? 0 ]} />);
    }

    sumMaxParticipacao = () => {
        const mirim1MaxParticipacao = this.props.schools.reduce((total, sch) => total + parseInt(sch.mirim1.maxParticipacao, 10), 0)
        const mirim2MaxParticipacao = this.props.schools.reduce((total, sch) => total + parseInt(sch.mirim2.maxParticipacao, 10), 0)
        const totalMaxParticipacao = this.props.schools.reduce((total, sch) => total + parseInt(sch.total.maxParticipacao, 10), 0)

        return (<Legenda params={[ mirim1MaxParticipacao ?? 0, mirim2MaxParticipacao ?? 0, totalMaxParticipacao ?? 0 ]} />);
    }

    // PAGINAÇÃO APENAS NA VIEW
    handlePage = (value) => this.setState({ ...this.state, page: value, });
    handleRowsPerPage = (value) => this.setState({ ...this.state, size: value, page: 0, });
    handleTotalPages = () => Math.ceil(this.props.schools.length / this.state.size);
    handleTotalElements = () => this.props.schools.length;

    render () {
        const columns = [
            { label: 'INEP', name: 'inep', func: null, key: true, width: '4', ordering: false, orderLabel: 'asc', },
            { label: 'Escola', name: 'nome', func: null, key: false, width: '10', ordering: false },
            { label: 'Dep. Adm.', name: 'dependencia', func: null, key: false, width: '4', ordering: false },
            { label: 'Modalidade', name: 'modalidade', func: patternModalidade, key: false, width: '7', ordering: false },
            { 
                label: 'Quantidade de Alunos para Certificado de Ouro',
                name: 'inep', 
                func: (value, id) => {
                    const school = this.props.schools.find(s => s.inep === id);
                    return (<Legenda params={[ school.mirim1.alunosOuro ?? 0, school.mirim2.alunosOuro ?? 0, school.total.alunosOuro ?? 0 ]} />);
                }, 
                key: false, 
                width: '8', 
                ordering: false 
            },
            { 
                label: 'Quantidade de Alunos para Certificado de Prata', 
                name: 'inep',
                func: (value, id) => {
                    const school = this.props.schools.find(s => s.inep === id);
                    return (<Legenda params={[ school.mirim1.alunosPrata ?? 0, school.mirim2.alunosPrata ?? 0, school.total.alunosPrata ?? 0 ]} />);
                }, 
                key: false, 
                width: '8', 
                ordering: false 
            },
            { 
                label: 'Quantidade de Alunos para Certificado de Bronze',
                name: 'inep', 
                func: (value, id) => {
                    const school = this.props.schools.find(s => s.inep === id);
                    return (<Legenda params={[ school.mirim1.alunosBronze ?? 0, school.mirim2.alunosBronze ?? 0, school.total.alunosBronze ?? 0 ]} />);
                }, 
                key: false, 
                width: '8', 
                ordering: false 
            },
            { 
                label: 'Quantidade de Alunos para Certificado de Participação',
                name: 'inep', 
                func: (value, id) => {
                    const school = this.props.schools.find(s => s.inep === id);
                    return (<Legenda params={[ school.mirim1.alunosParticipacao ?? 0, school.mirim2.alunosParticipacao ?? 0, school.total.alunosParticipacao ?? 0 ]} />);
                }, 
                key: false, 
                width: '8', 
                ordering: false 
            },
            { 
                label: 'Quantidade Máxima de Certificados de Ouro', 
                name: 'inep',
                func: (value, id) => {
                    const school = this.props.schools.find(s => s.inep === id);
                    return (<Legenda params={[ school.mirim1.maxOuro ?? 0, school.mirim2.maxOuro ?? 0, school.total.maxOuro ?? 0 ]} />);
                }, 
                key: false, 
                width: '8', 
                ordering: false 
            },
            { 
                label: 'Quantidade Máxima de Certificados de Prata', 
                name: 'inep',
                func: (value, id) => {
                    const school = this.props.schools.find(s => s.inep === id);
                    return (<Legenda params={[ school.mirim1.maxPrata ?? 0, school.mirim2.maxPrata ?? 0, school.total.maxPrata ?? 0 ]} />);
                }, 
                key: false, 
                width: '8', 
                ordering: false 
            },
            { 
                label: 'Quantidade Máxima de Certificados de Bronze',  
                name: 'inep',
                func: (value, id) => {
                    const school = this.props.schools.find(s => s.inep === id);
                    return (<Legenda params={[ school.mirim1.maxBronze ?? 0, school.mirim2.maxBronze ?? 0, school.total.maxBronze ?? 0 ]} />); 
                },
                key: false, 
                width: '8', 
                ordering: false 
            },
            { 
                label: 'Quantidade Máxima de Certificados de Participação', 
                name: 'inep',
                func: (value, id) => {
                    const school = this.props.schools.find(s => s.inep === id);
                    return (<Legenda params={[ school.mirim1.maxParticipacao ?? 0, school.mirim2.maxParticipacao ?? 0, school.total.maxParticipacao ?? 0 ]} />); 
                },
                key: false, 
                width: '8', 
                ordering: false 
            },
            { label: 'Municipio', name: 'municipio', func: null, key: false, width: '7', ordering: false },
            { label: 'Região', name: 'regiao', func: null, key: false, width: '5', ordering: false },
        ];
        
        const actions = [];

        const totals = [
            { column: 0, label: 'Totais', value: "#", width: '6', },
            { column: 1, label: 'Escolas', value: numberFormat(this.sumEscolas()), width: '6', },
            { column: 2, hidden: true, },
            { column: 3, hidden: true, },
            { column: 4, label: 'Totais de Alunos para Certificado de Ouro', value: this.sumAlunosOuro(), width: '11', },
            { column: 5, label: 'Totais de Alunos para Certificado de Prata', value: this.sumAlunosPrata(), width: '11', },
            { column: 6, label: 'Totais de Alunos para Certificado de Bronze', value: this.sumAlunosBronze(), width: '11', },
            { column: 7, label: 'Totais de Alunos para Certificado de Participação', value: this.sumAlunosParticipacao(), width: '11', },
            { column: 8, label: 'Totais Máximos de Certificados de Ouro', value: this.sumMaxOuro(), width: '11', },
            { column: 9, label: 'Totais Máximos de Certificados de Prata', value: this.sumMaxPrata(), width: '11', },
            { column: 10, label: 'Totais Máximos de Certificados de Bronze', value: this.sumMaxBronze(), width: '11', },
            { column: 11, label: 'Totais Máximos de Certificados de Participação', value: this.sumMaxParticipacao(), width: '11', },
            { column: 12, hidden: true, },
            { column: 13, hidden: true, },
        ];

        return (
            <Grid container spacing={3} style={{ marginTop: this.props.marginTop ?? 8 }}>
                <Grid item xs={12}>
                    <Table              
                        columns={columns}
                        tableData={this.props.schools.slice(this.state.page * this.state.size, (this.state.page * this.state.size) + this.state.size)}
                        actions={actions}
                        page={this.state.page}
                        handlePage={this.handlePage}
                        handleTotalPages={this.handleTotalPages}
                        handleTotalElements={this.handleTotalElements}
                        rowsPerPage={this.state.size}
                        handleRowsPerPage={this.handleRowsPerPage}
                        sort={null}
                        fixedHeader={true}
                    />
                </Grid>
                <Grid item xs={12}>
                    <Totals lineData={totals} columns={columns} showHead={true} />
                </Grid>
            </Grid>
        )
    }
}

export default DadosCertificados;